export default __webpack_public_path__ + "static/media/good_btn_heart_mark.1a3c1ca6.svg";